import { InverseHeader } from '@jouzen/ecom-components/layout';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';
import { SwipeableProvider } from '@jouzen/ecom-components/v3/SwipeableSlider';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useTranslations } from 'next-intl';

import { galleryImagesOR4 } from '@/app/[locale]/careers/_data/galleryImages';
import Section from '@/app/components/LegacyLandingPage/components/Section';

import Gallery from './Gallery';

const CareersGallery = () => {
  const t = useTranslations();

  return (
    <Section padTop data-cy="careers-gallery">
      <LayoutGrid>
        <Typography
          className="col-main mb-8 lg:mb-0"
          variant="h1"
          weight="light"
        >
          {t('how_it_started')}
        </Typography>
      </LayoutGrid>

      <LayoutGrid>
        <Typography className="col-main md:col-start-3 lg:col-start-6 lg:col-end-14 xl:col-end-13">
          {t('what_started_as_an_idea')}
        </Typography>
      </LayoutGrid>

      <InverseHeader enter>
        <LayoutGrid className="pt-12">
          <SwipeableProvider className="col-main">
            <Gallery images={galleryImagesOR4} />
          </SwipeableProvider>
        </LayoutGrid>
      </InverseHeader>
    </Section>
  );
};

export default CareersGallery;
